import { Component, OnInit } from '@angular/core';
import { RatesFooterService } from './rates-footer.service';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';

@Component({
  selector: 'app-rates-footer',
  templateUrl: './rates-footer.component.html',
  styleUrls: ['./rates-footer.component.scss']
})

export class RatesFooterComponent implements OnInit {

  //listado de tarifas
  ratesList:any;
  isShowModal = false;
  modalTitle = "";
  modalContent = "";

  //constructor del componente
  constructor(public LANG: CommonUtilitiesService, private ratesFooterService: RatesFooterService) { }

  
  /**
   * Description: Método que inicializa la lista de las tarifas
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  ngOnInit() {
    //ratesList se obitiene desde un ws
    this.ratesFooterService.getRateList({ "category": "ESPECIAL" }).subscribe((dataInfo => {
      if(dataInfo['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){
        this.ratesList = dataInfo['obj'];
      }else{
        this.modalTitle = "Error: ";
        this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
        this.isShowModal = true;        
      }
    }),
    (err) => {
      this.modalTitle = "Error: " + err.code;
      this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
      this.isShowModal = true;
    });
  }

  
  /**
   * Description: Método que agrega la url base de las imagenes en base 64
   * Autor: Diego Diaz
   * @param base64Img imagen a mostrar en base 64
   * @return Data de la imagen con la base de la url
   */
  formatImg(base64Img) {
    return constants.BASE64_INIT + base64Img;
  }

}
